<template>
  <PageView v-if="page_module" :page-reference="PAGE_REFERENCES.PROSPECTING" :current-object-type="default_object_type_obj">
    <template #header>
      <TripleMenu
        v-if="$route.params?.page"
        :set-edit-mode="setEditMode"
        :edit-mode-active="edit_mode_active"
        :quick-actions="[]"
        :current-template="current_template"
        :components-actions="top_right_menu_components_actions"
        :page-reference="PAGE_REFERENCES.PROSPECTING" />
    </template>
    <template #body>
      <LayoutContainer
        key="prospecting"
        v-model:current-template="current_template"
        :set-edit-mode="setEditMode"
        :edit-mode-active="edit_mode_active"
        class="mt-0"
        :page-reference="PAGE_REFERENCES.PROSPECTING" />
    </template>
  </PageView>
</template>

<script>
import TripleMenu from "@/components/shared/TripleMenu.vue"
import LayoutContainer from "@/components/shared/pages/LayoutContainer.vue"
import ModuleIcon from "@/components/shared/icons/ModuleIcon.vue"
import PageView from "@/components/shared/pages/PageView.vue"
import { PAGE_REFERENCES, PAGE_REFERENCES_MODULES } from "@/store/constants/references"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
export default {
  components: {
    TripleMenu,
    LayoutContainer,
    PageView
  },
  inject: ["getModule"],
  beforeRouteLeave() {
    // called when the route that renders this component is about to be navigated away from.
    if (this?.edit_mode_active) {
      const answer = window.confirm(this.$t("You have unsaved changes, layout will be reverted if you don't save"))
      if (!answer) {
        return false
      } else {
        this.edit_mode_active = false
      }
    }
  },
  data() {
    return {
      PAGE_REFERENCES,
      page_module: null,
      edit_mode_active: false,
      current_template: null,
      default_object_type_obj: { type: "default" }
    }
  },
  computed: {
    top_right_menu_components_actions() {
      return [
        {
          name: this.$t("Edit Layout"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.EDIT_LAYOUT, {
              page_reference: PAGE_REFERENCES.PROSPECTING,
              page_name: this.$route.params.page
            })
          },
          disabled: false,
          keyBoardShortcut: "I",
          icon: ModuleIcon
        },
        {
          name: this.$t("Add/Remove Components"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.ADD_NEW_COMPONENT, {
              page_reference: PAGE_REFERENCES.PROSPECTING,
              current_template: this.current_template
            })
          },
          disabled: false,
          keyBoardShortcut: "U",
          icon: ModuleIcon
        },
        {
          name: this.current_template?.is_static ? this.$t("Reset Page") : this.$t("Delete Page"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.DELETE_PAGE, this.current_template)
          },
          icon: ModuleIcon
        }
      ]
    }
  },
  created() {
    this.getPageModule()
  },
  methods: {
    getPageModule() {
      this.page_module = this.getModule(PAGE_REFERENCES_MODULES[PAGE_REFERENCES.PROSPECTING])
      if (!this.page_module) {
        setTimeout(() => {
          this.getPageModule()
        }, 500)
      }
    },
    setEditMode(value) {
      this.edit_mode_active = value
    }
  }
}
</script>
